export const EEmissionAccountColumnKeys = {
  ID: 'id',
  WalletAccountGuid: 'wallet_account_guid',
  Currency: 'currency',
  Branch: 'branch_name',
  AccountName: 'account_name',
  ActualBalance: 'actual_balance',
  IssuerBurnSaldo: 'issue_burn_saldo',
  ReserveAcc: 'reserve_acc',
  AccountStatus: 'account_status',
  IBAN: 'iban',
  StellarAddress: 'stellar_address',
  WalletUserExternalId: 'wallet_user_external_id',
} as const;

export const EQueryParams = {
  Page: 'page',
  PageSize: 'page_size',
  CounterpartyGuid: 'counterparty_guid',
  Created: 'created',
  IBAN: 'iban',
  WalletAccountGUID: 'wallet_account_guids',
} as const;
